import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ffde200&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=coffee&"
export * from "./index.vue?vue&type=script&lang=coffee&"
import style0 from "./index.vue?vue&type=style&index=0&id=7ffde200&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffde200",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TraceTableHeading: require('/opt/build/repo/nuxt-app/components/globals/trace/table/heading.vue').default,TraceTableRow: require('/opt/build/repo/nuxt-app/components/globals/trace/table/row.vue').default,Wysiwyg: require('/opt/build/repo/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default})
